import * as baseContext from "@repo/helpers/src/contexts/pendingChangesContext";
import { useContext } from "react";

export const PendingChangesContext = baseContext.getPendingChangesContext<itemType>();

export const usePendingChangesContext = () => useContext(PendingChangesContext);
export const useUpdatePendingChanges = (type: itemType) => baseContext.useUpdatePendingChanges(type);
export const PendingChangesProvider = baseContext.PendingChangesProvider;
export type itemType = "location" | "statusHistory" | "associationsInfo" | "repFieldAudit";
